import { IPublicClientApplication } from "@azure/msal-browser";
import { apiLoginRequest } from "../Config";
import Driver from "../Models/Driver";
import MileAgeResponse from "../Models/Responses/MileAgeResponse";
import ChargeResponse from "../Models/Responses/ChargeResponse";
import Charge from "../Models/Charge";
import ChargeRate from "../Models/ChargeRate";
import ChargePayout from "../Models/ChargePayout";
import ChargePayoutResponse from "../Models/Responses/ChargePayoutResponse";

export default class DriverService {
    msalInstance: IPublicClientApplication;

    constructor(msalInstance: IPublicClientApplication) {
        this.msalInstance = msalInstance;
    }

    public async getDriverByEmployeeContactId(employeeContactId: string): Promise<Driver> {
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/GetDriverByContactId`;
        let companyCar: Driver = null as any;
        const accessToken = await this.acquireAccessToken();

        await fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,

            }),
            body: JSON.stringify(employeeContactId)
        }).then(async function (response) {
            if (response.status === 500) {
                throw new Error();
            }

            await response.json().then(data => {
                if (data) {
                    companyCar = mapJsonObjectToCompanyCar(data);
                }
            })
        }).catch((error: Error) => {
            console.log(error.message)
        });

        return companyCar;
    }


    public async GetChargesByEmployeeContactId(employeeContactId: string)/*: Promise<Charge[]>*/{

        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/GetAllCharges`
        let charges: Charge[] = []
        const accessToken = await this.acquireAccessToken();

      
        await fetch(url, {
            method:'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
            }),
            body: JSON.stringify(employeeContactId)
        }).then(async function(response) {
            if(response.status === 500){
                throw new Error();
            }

            await response.json().then(data => {
                if(data && data.Result){
                    charges = data.Result.map((chargeData: any) => mapJsonObjectToCharges(chargeData));
                }
                
            }).catch((error: Error) => {
                console.log(error.message)
            })
        })

        return charges;
    }


  
    public async addMileAge(mileAge: MileAgeResponse)
    {
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/AddMileAge`;
        const accessToken = await this.acquireAccessToken();
        let isAdded = false;

        await fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
                'OnPremisesUserPrincipalName': sessionStorage.getItem('onPremisesUserPrincipalName') ?? ""
            }),
            body: JSON.stringify(mileAge)
        }).then(async function (response) {
            if (response.status === 500) {
                throw new Error();
            }

            isAdded = true;
        }).catch((error: Error) => {
            console.log(error.message)
        });

        return isAdded;
    }


    public async AddCharge(chargeResponse:ChargeResponse){
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/AddCharge`
        const accessToken = await this.acquireAccessToken();
        let isAdded = false;

        await fetch(url,{
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
                'OnPremisesUserPrincipalName': sessionStorage.getItem('onPremisesUserPrincipalName') ?? ""
            }),
            body: JSON.stringify(chargeResponse)
        }).then(async function (response){
            if(response.status === 500){
                throw new Error();
            }
            isAdded = true;
        }).catch((error:Error) =>{
            console.log(error.message)
        })

        return isAdded;
    }

    public async AddChargePayout(chargePayoutResponse:ChargePayoutResponse){
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/AddChargePayout`
        const accessToken = await this.acquireAccessToken();
        let isAdded = false;

        await fetch(url,{
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
                'OnPremisesUserPrincipalName': sessionStorage.getItem('onPremisesUserPrincipalName') ?? ""
            }),
            body: JSON.stringify(chargePayoutResponse)
        }).then(async function (response){
            if(response.status === 500){
                throw new Error();
            }
            isAdded = true;
        }).catch((error:Error) =>{
            console.log(error.message)
        })

        return isAdded;
    }

    public async UpdateCharge(chargeId: string, newStateCode: number){
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/UpdateCharge/${chargeId}`
        const accessToken = await this.acquireAccessToken();

        await fetch(url, {
            method:'PATCH',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
                'OnPremisesUserPrincipalName': sessionStorage.getItem('onPremisesUserPrincipalName') ?? ""
            }),
            body: JSON.stringify({stateCode: newStateCode})
        }).then(async function (response){
            if(response.status === 500){
                throw new Error();
            }
        }).catch((error: Error) =>{
            console.log(error.message)
        });
    }
    
   

    public async GetAllChargeRates(): Promise<ChargeRate[]> {
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/GetAllChargeRates`
        let chargeRates : ChargeRate[] = [];
        const accessToken = this.acquireAccessToken();

        await fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
            }),
        }).then(async function(response) {
            await response.json().then(data => {
                if(response.status === 500){
                    throw new Error();
                }
                if(data){
                    data.forEach((responseObject: any) =>{
                        let chargeRate: ChargeRate = mapJsonObjectToChargeRates(responseObject)
                        chargeRates.push(chargeRate);
                    })
                }
            })
        }).catch((error: Error) =>{
            console.log(error.message)
        })
        return chargeRates;
    }

    public async GetAllChargePayoutsByEmployeeContactId(employeeContactId: string) /*Promise<ChargePayout[]>*/{
        
        let baseUrl = process.env.REACT_APP_API_URI;
        let url = `${baseUrl}/api/GetAllChargePayoutsByEmployeeContactId`
        let chargePayouts: ChargePayout[] = []
        const accessToken = await this.acquireAccessToken();

      
        await fetch(url, {
            method:'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
            }),
            body: JSON.stringify(employeeContactId)
        }).then(async function(response) {
            if(response.status === 500){
                throw new Error();
            }

            await response.json().then(data => {
                if(data && data.Result){
                    chargePayouts = data.Result.map((chargePayout: any) => mapJsonObjectToChargePayout(chargePayout));
                }
                
            }).catch((error: Error) => {
                console.log(error.message)
            })
        })

        return chargePayouts;

    }

    private async acquireAccessToken() {
        const account = this.msalInstance.getActiveAccount();
        if (!account) {
            throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }

        const authResult = await this.msalInstance.acquireTokenSilent({
            ...apiLoginRequest,
            account: account
        });

        return authResult.accessToken;
    };
}

function mapJsonObjectToCompanyCar(jsonObject: any): Driver {
    return {
        contactId: jsonObject.ContactId,
        startDate: jsonObject.StartDate,
        endDate: jsonObject.EndDate,
        driverId: jsonObject.DriverId,
        companyCar: {
            companyCarId: jsonObject.CompanyCar?.CompanyCarId,
            ownerId: jsonObject.CompanyCar?.OwnerId,
            licensePlate: jsonObject.CompanyCar?.LicensePlate,
            chassisNumber: jsonObject.CompanyCar?.ChassisNumber,
            firstRegistration: jsonObject.CompanyCar?.FirstRegistration,
            fuelType: jsonObject.CompanyCar?.FuelType,
            co2: jsonObject.CompanyCar?.Co2,
            batteryCapacity: jsonObject.CompanyCar?.BatteryCapacity,
            type: jsonObject.CompanyCar?.Type,
            insuranceNumber: jsonObject.CompanyCar?.InsuranceNumber,
            fleetNumber: jsonObject.CompanyCar?.FleetNumber,
            franchise: jsonObject.CompanyCar?.Franchise,
            brand: {
                id: jsonObject.CompanyCar?.Brand?.Id,
                name: jsonObject.CompanyCar?.Brand?.Name,
            },
            mileAge: {
                date: jsonObject.CompanyCar?.MileAge?.Date,
                mileAgeNumber: jsonObject.CompanyCar?.MileAge?.MileAgeNumber
            }
        }
    }
}

function mapJsonObjectToCharges(jsonObject: any): Charge{
    return {
        chargeDate: new Date(jsonObject.ChargeDate),
        chargePercentage: parseFloat(jsonObject.ChargePercentage),
        chargeCost: parseFloat(jsonObject.ChargeCost),
        chargeId: jsonObject.ChargeId,
        chargePayout: {
            chargePayoutId: jsonObject.ChargePayout?.ChargePayoutId,
            chargeCode: jsonObject.ChargePayout?.ChargeCode,
            driverId: jsonObject.ChargePayout?.DriverId,
            companyCar: jsonObject.ChargePayout?.CompanyCar,
            payoutTotal: parseFloat(jsonObject.ChargePayout?.PayoutTotal),
            averageChargeCost: parseFloat(jsonObject.ChargePayout?.AverageChargeCost),
            amountOfCharges: parseInt(jsonObject.ChargePayout?.AmountOfCharges),
            payoutStatus: parseInt(jsonObject.ChargePayout?.PayoutStatus),
            payoutDate: new Date(jsonObject.ChargePayout?.PayoutDate),
        },
        stateCode: parseFloat(jsonObject.StateCode),

    };
}

function mapJsonObjectToChargePayout(jsonObject: any): ChargePayout{
    
    return {
        chargePayoutId: jsonObject.ChargePayoutId,
        chargeCode: jsonObject.ChargeCode,
        driverId: jsonObject.DriverId,
        payoutTotal: parseFloat(jsonObject.PayoutTotal),
        averageChargeCost: parseFloat(jsonObject.AverageChargeCost),
        amountOfCharges: parseInt(jsonObject.AmountOfCharges),
        payoutStatus: parseInt(jsonObject.PayoutStatus),
        payoutDate: new Date(jsonObject.PayoutDate),
        companyCar: {
            companyCarId: jsonObject.CompanyCar?.CompanyCarId,
            ownerId: jsonObject.CompanyCar?.OwnerId,
            licensePlate: jsonObject.CompanyCar?.LicensePlate,
            chassisNumber: jsonObject.CompanyCar?.ChassisNumber,
            firstRegistration: jsonObject.CompanyCar?.FirstRegistration,
            fuelType: jsonObject.CompanyCar?.FuelType,
            co2: jsonObject.CompanyCar?.Co2,
            batteryCapacity: jsonObject.CompanyCar?.BatteryCapacity,
            type: jsonObject.CompanyCar?.Type,
            insuranceNumber: jsonObject.CompanyCar?.InsuranceNumber,
            fleetNumber: jsonObject.CompanyCar?.FleetNumber,
            franchise: jsonObject.CompanyCar?.Franchise,
            brand: {
                id: jsonObject.CompanyCar?.Brand?.Id,
                name: jsonObject.CompanyCar?.Brand?.Name,
            },
            mileAge: {
                date: jsonObject.CompanyCar?.MileAge?.Date,
                mileAgeNumber: jsonObject.CompanyCar?.MileAge?.MileAgeNumber
            }
        }
  
    }
}

function mapJsonObjectToChargeRates(jsonObject: any): ChargeRate{
    return {
        chargeRateId: jsonObject.ChargeRateId,
        startDate: new Date(jsonObject.StartDate),
        endDate: new Date(jsonObject.EndDate),
        rate: parseFloat(jsonObject.Rate),
        monthCode: jsonObject.MonthCode
    }
}
